declare global {
  interface IntlDateTimeFormatOptions extends Intl.DateTimeFormatOptions {
    dateStyle?: 'full' | 'long' | 'medium' | 'short'
    timeStyle?: 'full' | 'long' | 'medium' | 'short'
  }
}

interface IFormatDate extends Intl.DateTimeFormatOptions {
  date?: Date
}

export const formatDate = ({ date, dateStyle, timeStyle }: IFormatDate) => {
  if (date === null || date === undefined) return ''

  const val = transformDate(date)

  return Intl.DateTimeFormat('cs-CZ', {
    dateStyle,
    timeStyle,
  }).format(val)
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const transformDate = (date: any) => (date ? new Date(date) : undefined)
